import { Component, Inject, OnInit, signal } from "@angular/core";
import { UntypedFormBuilder } from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { MatMenuTrigger } from "@angular/material/menu";
import { PageEvent } from "@angular/material/paginator";

import { Router } from "@angular/router";
import { EvaluationService } from "app/services/evaluation/evaluation.service";
import { ImagesService } from "app/services/helper/images.service";
import moment from "app/util/dayjs";
@Component({
    selector: "app-dialog-notas-evaluacion",
    templateUrl: "./dialog-notas-evaluacion.component.html",
    styleUrls: ["./dialog-notas-evaluacion.component.scss"],
    standalone: false
})
export class DialogNotasEvaluacionComponent implements OnInit {
    personas: Array<any> = [];
    evaluado: any;
    period: any;
    procesando: boolean = false;
    page = 0;
    allperiod = 0;
    readonly totalNotas = signal(0);

    readonly notas = signal<any[]>([]);
    selectedNota: null;
    newNotaName = "";

    notaActualizar = "";

    public displayedColumns: string[] = ["nota", "fecha", "actions"];

    constructor(
        private formBuilder: UntypedFormBuilder,
        private evSvc: EvaluationService,
        private router: Router,
        @Inject(MAT_DIALOG_DATA) public dialogData: any,
        private imagesSvc: ImagesService,
        private dialogRef: MatDialogRef<DialogNotasEvaluacionComponent> // Inyecta MatDialogRef
    ) {
        this.evaluado = dialogData.evaluado;
        this.period = dialogData.period;
    }
    ngOnInit() {
        this.getNotas();
    }

    cerrar() {
        this.dialogRef.close();
    }

    getNotas() {
        this.evSvc
            .getAnnotationes(8, this.page, this.evaluado, { period: this.period.id, allperiod: this.allperiod })
            .subscribe((data) => {
                this.notas.set([...(data.anotaciones ?? [])]);
                console.log(this.notas());
            });
        this.evSvc
            .getAnnotationesTotal(this.evaluado, { period: this.period.id, allperiod: this.allperiod })
            .subscribe((data) => {
                this.totalNotas.set(data.total ?? 0);
                console.log(this.totalNotas());
            });
    }

    parseDate(date) {
        if (date) {
            return moment(date).format("DD-MM-YYYY HH:mm");
        } else {
            return "";
        }
    }

    pageChanged(event: PageEvent) {
        this.page = event.pageIndex;
        this.getNotas();
    }

    eliminar(nota) {
        this.evSvc.deleteNota(nota.id).subscribe((data) => {
            this.getNotas();
        });
    }
    anadirNota(menuTrigger: MatMenuTrigger) {
        this.evSvc.postNota({ nota: this.newNotaName, personId: this.evaluado }).subscribe((data) => {
            this.newNotaName = "";
            this.getNotas();
            menuTrigger.closeMenu();
        });
    }
    editarNota(nota, menuTrigger: MatMenuTrigger) {
        this.evSvc.updateNota(nota.id, this.notaActualizar).subscribe((data) => {
            this.notaActualizar = "";
            this.getNotas();
            menuTrigger.closeMenu();
        });
    }

    changeAllperiod($event) {
        this.allperiod = $event.checked ? 1 : 0;
        this.page = 0;
        this.getNotas();
    }
    selectNota(nota) {
        this.notaActualizar = String(JSON.parse(JSON.stringify(nota)));
    }
}
